<template>
  <div>
    <div class="row">
      <sj-checkbox v-model="value" label="default border" />
      <sj-checkbox v-model="value" size="large" label="large border" />
      <sj-checkbox v-model="value" size="small" label="small border" />
      <sj-checkbox v-model="value" size="mini" label="mini border" />
      <sj-checkbox v-model="value" size="middle" label="middle border" />

      <sj-checkbox
        v-model="value"
        size="large"
        indeterminate
        label="large border indeterminate"
      />

      <sj-checkbox
        v-model="value"
        size="middle"
        disabled
        label="middle border disabled"
      />

      <sj-checkbox
        v-model="value"
        size="large"
        indeterminate
        disabled
        label="large border indeterminate disabled"
      />
    </div>

    <div class="row">
      <sj-checkbox v-model="value" theme="fill" label="default fill" />
      <sj-checkbox
        v-model="value"
        theme="fill"
        size="large"
        label="large fill"
      />
      <sj-checkbox
        v-model="value"
        theme="fill"
        size="small"
        label="small fill"
      />
      <sj-checkbox v-model="value" theme="fill" size="mini" label="mini fill" />
      <sj-checkbox
        v-model="value"
        theme="fill"
        size="middle"
        label="middle fill"
      />

      <sj-checkbox
        v-model="value"
        theme="fill"
        size="large"
        indeterminate
        label="large fill indeterminate"
      />

      <sj-checkbox
        v-model="value"
        theme="fill"
        size="middle"
        disabled
        label="middle fill disabled"
      />

      <sj-checkbox
        v-model="value"
        theme="fill"
        size="large"
        indeterminate
        disabled
        label="large fill indeterminate disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: false
    };
  }
};
</script>

<style scoped lang="less">
.row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  > * {
    margin-right: 20px;
  }
}
</style>
